import styled from 'styled-components'

import { CardOrientation } from '../../customCard/base/enum'

import { GridOrientation } from '../enum'
import type { BaseGridProps } from '../types'

const Grid = styled.section<{
  cardOrientation?: CardOrientation
  gridOrientation?: GridOrientation
}>`
  display: grid;
  grid-gap: var(--spacer-7);
  align-items: start;
  ${({ cardOrientation, gridOrientation }) =>
    gridOrientation === GridOrientation.HORIZONTAL
      ? `
      grid-template-columns: repeat(auto-fit, minmax(${
        cardOrientation === CardOrientation.HORIZONTAL ? '33.75rem' : '18.75rem'
      }, 1fr));
    `
      : `
      grid-template-columns: repeat(auto-fill, minmax(16.015rem, 1fr));
    `}
`

const GridDefaultDesktop = ({
  children,
  cardOrientation,
  gridOrientation,
  className
}: BaseGridProps) => {
  return (
    <Grid
      cardOrientation={cardOrientation}
      gridOrientation={gridOrientation}
      className={className}
      data-test='default-base-grid'>
      {children}
    </Grid>
  )
}

export default GridDefaultDesktop
